class MCartDrawer extends HTMLElement {
    constructor() {
        super(),
        this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner"),
        this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close"),
        this.cartOverlay = this.querySelector(".m-cart__overlay"),
        this.rootUrl = window.Shopify.routes.root,
        this.setHeaderCartIconAccessibility(),
        this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this)),
        this.addEventListener("click", (t=>{
            t.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner && this.close()
        }
        ))
    }
    setHeaderCartIconAccessibility() {
        document.querySelectorAll(".m-cart-icon-bubble").forEach((t=>{
            t.setAttribute("role", "button"),
            t.setAttribute("aria-haspopup", "dialog"),
            t.addEventListener("click", (e=>{
                MinimogSettings.enable_cart_drawer && (e.preventDefault(),
                this.open(t))
            }
            ))
        }
        ))
    }
    open(t) {
        t && this.setActiveElement(t),
        this.classList.add("m-cart-drawer--active"),
        requestAnimationFrame((()=>{
            this.style.setProperty("--m-bg-opacity", "0.5"),
            this.cartDrawerInner.style.setProperty("--translate-x", "0")
        }
        )),
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer),
        document.documentElement.classList.add("prevent-scroll")
    }
    close() {
        this.style.setProperty("--m-bg-opacity", "0"),
        this.cartDrawerInner.style.setProperty("--translate-x", "100%"),
        setTimeout((()=>{
            this.classList.remove("m-cart-drawer--active"),
            document.documentElement.classList.remove("prevent-scroll")
        }
        ), 300)
    }
    renderContents(t) {
        this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty"),
        this.productId = t.id,
        this.getSectionsToRender().forEach((e=>{
            (e.selector ? document.querySelector(e.selector) : document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector)
        }
        )),
        setTimeout((()=>{
            this.open(),
            window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart()
        }
        ))
    }
    updateCartCount(t) {
        document.querySelectorAll(".m-cart-count-bubble").forEach((e=>{
            t > 0 ? (e.textContent = t,
            e.classList.remove("hidden")) : e.classList.add("hidden")
        }
        ))
    }
    getCart() {
        return fetchJSON(this.rootUrl + "cart.json")
    }
    onCartDrawerUpdate(t=!0,open) {
        fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`).then((t=>t.text())).then((e=>{
                this.getSectionsToRender().forEach((r=>{
                    if ("cart-items" === r.block) {
                        (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(e, r.selector),
                        window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart()
                    } else if (t) {
                        (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(e, r.selector)
                    }
                }
            ))
        }
        )).catch((t=>{}
        )),
        this.getCart().then((t=>{
            this.classList.toggle("m-cart--empty", 0 === t.item_count),
            this.updateCartCount(t.item_count)
        }
        ))
    }
    getSectionInnerHTML(t, e=".shopify-section") {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML
    }
    getSectionsToRender() {
        return [{
            id: "cart-drawer",
            selector: "[data-minimog-cart-items]",
            block: "cart-items"
        }, {
            id: "cart-drawer",
            selector: "[data-minimog-cart-discounts]",
            block: "cart-footer"
        }, {
            id: "cart-drawer",
            selector: "[data-cart-subtotal]",
            block: "cart-footer"
        }, {
            id: "cart-drawer",
            selector: "[data-minimog-gift-wrapping]",
            block: "cart-footer"
        },{
            id: "cart-drawer",
            section: "cart-shipping-process",
            selector: "[data-minimog-cart-process]"
        }]
    }
    getSectionDOM(t, e=".shopify-section") {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e)
    }
    setActiveElement(t) {
        this.activeElement = t
    }
}
customElements.define("m-cart-drawer", MCartDrawer);
class MCartDrawerItems extends MCartTemplate {
    getSectionsToRender() {
        return [{
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-items]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-discounts]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-cart-subtotal]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-gift-wrapping]"
        },{
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-process]"
        }]
    }
}
customElements.define("m-cart-drawer-items", MCartDrawerItems);

class cartRecommendations extends MCartTemplate{
    constructor(parent) {
        // this.parent = parent;
        super();
        this.clickEvent();
        this.init();
    }

    ajaxCart = async(id) =>{
        try{
            let data = await fetch('/cart/add.js',{
                  method: "POST",
                  headers: {
                      'Content-Type': 'application/json'
                  },
                    body: JSON.stringify({
                        id:id, quantity:1
                    })
                });
            let res = await data.json();
            return res;
          }catch(e){
              console.log(e);
          }
    }

    clickEvent = () =>{
        let btns = this.querySelectorAll('.m-choose-button');
        let closebtns = this.querySelectorAll('.close-btn');
        let addBtns = this.querySelectorAll('.add-button');
        let swatchBtns = this.querySelectorAll('.swatch-item');
        const cart = document.querySelector('m-cart-drawer')

        swatchBtns.forEach((item)=>{
            item.addEventListener('click',(e)=>{
                e.preventDefault();
                let parent = e.target.closest('.product-container');
                let swatchWrap = e.target.closest('.swatch-wrap');
                swatchWrap.querySelectorAll('.swatch-item').forEach((item)=> item.classList.remove('active'));
                let vSelector = parent.querySelector('.swatch-items');
                e.target.classList.add('active');
                let option = swatchWrap.closest('.option-container');
                option.classList.add('active');
                let allOptions = parent.querySelectorAll('.option-container');
                let found = false;
                for(let i=0; i< allOptions.length; i++){
                    let op = allOptions[i];
                    if(!op.classList.contains('active')){
                        parent.querySelector('.add-button').innerHTML = op.querySelector('.option-name').innerHTML;
                        found = true;
                        break;
                    }
                }
                if(!found){
                    parent.querySelector('.add-button').classList.add('active');
                    const product = JSON.parse(parent.querySelector('.product-data').innerHTML);
                    let variant = null;
                    if(allOptions.length == 1){
                        variant = product.variants.find((v)=> v.option1 == allOptions[0]?.querySelector('.swatch-item.active')?.dataset?.value);
                    }else if(allOptions.length == 2){
                        variant = product.variants.find((v)=> v.option1 == allOptions[0]?.querySelector('.swatch-item.active')?.dataset?.value && v.option2 == allOptions[1]?.querySelector('.swatch-item.active')?.dataset?.value);
                    }else if(allOptions.length == 3){
                        variant = product.variants.find((v)=> v.option1 == allOptions[0]?.querySelector('.swatch-item.active')?.dataset?.value && v.option2 == allOptions[1]?.querySelector('.swatch-item.active')?.dataset?.value && v.option3 == allOptions[2]?.querySelector('.swatch-item.active')?.dataset?.value);
                    }
                    console.log("variant",variant)
                    if(variant){
                        if(variant.available){
                            parent.querySelector('.add-button').innerHTML = "Add";
                            parent.querySelector('.add-button').setAttribute('data-id',variant.id);
                            parent.querySelector('.add-button').removeAttribute('disabled');
                        }else{
                            parent.querySelector('.add-button').innerHTML = "Sold out";
                            parent.querySelector('.add-button').setAttribute('disabled',true);
                        }
                    }else{
                        parent.querySelector('.add-button').setAttribute('disabled',true);
                        parent.querySelector('.add-button').innerHTML = "Unavailable"
                    }
                }
            })
        })

        
        btns.forEach((item)=>{
            item.addEventListener('click',(e)=>{
                e.preventDefault();
                let parent = e.target.closest('.product-container');
                let vSelector = parent.querySelector('.swatch-items');
                if(vSelector){
                    vSelector.classList.add('active');
                }
            })
        })

        closebtns.forEach((item)=>{
            item.addEventListener('click',(e)=>{
                let parent = e.target.closest('.product-container');
                let vSelector = parent.querySelector('.swatch-items');
                if(vSelector){
                    vSelector.classList.remove('active');
                }
            })
        })
        addBtns.forEach((item)=>{
            item.addEventListener('click',async (e)=>{
                let parent = e.target.closest('.product-container');
                if(!e.target.classList.contains('active')){
                    return
                }
                const data = await this.ajaxCart(e.target.dataset.id);
                cart.onCartDrawerUpdate();
                cart.open()
            })
        })
    }
    swiper = () => {
        // let parent = this.parent;
        // parent.forEach(parent => {
            let recommendationsSwiper = this.querySelector('.cart-recommendations-js');
            const swiper = new MinimogLibs.Swiper(recommendationsSwiper, {
                slidesPerView: 1,
                spaceBetween: 10,
                freeMode: false,
                navigation: {
                  nextEl: this.querySelector(".swiper-button-next"),
                  prevEl: this.querySelector(".swiper-button-prev"),
                },
                pagination: {
                    el: this.querySelector(".swiper-pagination"),
                    clickable: true,
                },
            });
        // })
    }

    init = () => {
        setTimeout(()=>{
        this.swiper();
        },5000)
    }
}
customElements.define("cart-recommendations", cartRecommendations);


class freeGift extends HTMLElement {
    constructor() {
        super();
        // if (parent.lenth == 0) {
        //     return
        // }
        this.product = window.freeGiftProduct;
        // this.parent = null;
        this.init();
    }

    ajaxCart = async(id) =>{
        try{
            let data = await fetch('/cart/add.js',{
                  method: "POST",
                  headers: {
                      'Content-Type': 'application/json'
                  },
                    body: JSON.stringify({
                        id:id, quantity:1
                    })
                });
            let res = await data.json();
            return res;
          }catch(e){
              console.log(e);
          }
    }

    getVariant = () =>{
        let selectors = this.querySelectorAll('.free-gift-select');
        let variant = null;
         if(selectors.length == 1){
            variant = this.product.variants.find((item)=> item.option1 == selectors[0].value);
            
         }else if(selectors.length == 2){
            variant = this.product.variants.find((item)=> item.option1 == selectors[0].value && item.option2 == selectors[1].value);
            
         }else if(selectors.length == 3){
            variant = this.product.variants.find((item)=> item.option1 == selectors[0].value && item.option2 == selectors[1].value && item.option3 == selectors[2].value);
         }
         return variant;
    }
    updateData = (variant) =>{
        console.log("variant",variant);
        let price = this.querySelector('.m-cart-item__price--regular');
        price.innerHTML = formatMoney(variant.price);
        let btn = this.querySelector('.free-add-btn');
        if(variant){
            if(variant.available){
                btn.removeAttribute('disabled');
                btn.innerHTML = 'Add';
                btn.setAttribute('data-id',variant.id);
            }else{
                btn.innerHTML = 'Sold out'
                btn.setAttribute('disabled', true);
            }
        }else{
            btn.innerHTML = 'Unavailable'
            btn.setAttribute('disabled', true);
        }
    }
    changeEvent = () => {
        let selectors = this.querySelectorAll('.free-gift-select');
        const cart = document.querySelector('m-cart-drawer')
        selectors.forEach(item => {
            item.addEventListener('change',(e)=>{
                setTimeout(()=>{
                    const variant = this.getVariant();
                    this.updateData(variant);
                },500)
            })
        })
        const freeGiftBtn = this.querySelector(".free-add-btn");
        freeGiftBtn.addEventListener('click',async (e)=>{
            // window.addFreegift(e.target);
            const data = await this.ajaxCart(e.target.dataset.id);
            cart.onCartDrawerUpdate();
            cart.open()
        })
    }

    init = () => {
        this.changeEvent();
    }
}
customElements.define("cart-free-gift", freeGift);
